import { render } from "./CompanyStory.vue?vue&type=template&id=39dde5ca"
import script from "./CompanyStory.vue?vue&type=script&lang=js"
export * from "./CompanyStory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__